import { render, staticRenderFns } from "./assurPlus.vue?vue&type=template&id=52f2e81c&scoped=true"
import script from "./assurPlus.vue?vue&type=script&lang=js"
export * from "./assurPlus.vue?vue&type=script&lang=js"
import style0 from "./assurPlus.vue?vue&type=style&index=0&id=52f2e81c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f2e81c",
  null
  
)

export default component.exports